<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <vx-card class="mb-5">
      <a
        :href="link.url"
        target="_blank"
        v-for="(link, index) in sortedOperationLinks"
        :key="index"
        class="text-black block hover:pl-5"
        :class="{ 'pointer-events-none': link.linkType != 'Any' }"
      >
        <li
          class="
            p-4
            mb-3
            flex
            justify-between
            items-center
            border border-light-grey
            rounded-lg
            cursor-pointer
          "
          :class="{ 'opacity-50': link.linkType != 'Any' }"
          style="background-color: #f8fafb"
        >
          <div class="flex items-center">
            <div style="width: 50px" class="flex justify-center">
              <div v-if="link.icon">
                <img
                  :src="link.icon"
                  alt="Link icon"
                  style="width: 50px; max-width: 50px; max-height: 50px"
                />
              </div>
              <feather-icon
                v-else
                icon="LinkIcon"
                svgClasses="h-4 w-4"
                class="p-2 inline-flex rounded-md bg-white border border-light-grey shadow"
              ></feather-icon>
            </div>
            <div>
              <p class="ml-4 text-gray-700 font-semibold font-sans tracking-wide">
                {{ link.title }}
              </p>
              <p class="ml-4 text-gray-600 font-sans tracking-wide">
                {{ link.description }}
              </p>
              <p class="ml-4 text-grey font-sans tracking-wide max-w-md truncate">
                {{ link.url }}
              </p>
            </div>
          </div>

          <div class="flex">
            <div v-for="country in link.countries" :key="country">
              <img v-if="country" width="24" class="opacity-75 mx-1" :src="countryToFlag(country)" />
              <div v-else>Unknown country</div>
            </div>
          </div>
        </li>
      </a>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FlagDK from "@/assets/images/flags/dan.png";
import FlagNO from "@/assets/images/flags/nor.png";
import FlagFI from "@/assets/images/flags/fin.png";
import FlagUK from "@/assets/images/flags/eng.png";

import _ from "lodash";

export default {
  components: {},
  data() {
    return {
      FlagDK,
      FlagNO,
      FlagFI,
      FlagUK,
    };
  },
  methods: {
    countryToFlag(country) {
      switch (country) {
        case "DK":
          return FlagDK;
        case "NO":
          return FlagNO;
        case "FI":
          return FlagFI;
        case "UK":
          return FlagUK;
        default:
          return null;
      }
    },
  },
  computed: {
    ...mapGetters({
      operationLinks: "operationLinks/operationLinks",
      isLoading: "operationLinks/loading",
      activeVenue: "venues/activeVenue",
    }),
    sortedOperationLinks() {
      // All non-any operation links in the bottom
      return _.sortBy(this.operationLinks, e => e.deviceType != "Any");
    },
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("operationLinks/getAll", this.activeVenue.venueId);
    console.log("Got operation links", this.operationLinks);
  },
};
</script>

<style lang="scss">
</style>